"use client"
import { Form } from "@opensea/ui-kit"
import { useFormContext } from "react-hook-form"
import { useSwapContext } from "../provider/SwapContext"
import type { SwapFlowFormValues } from "../types"

type SwapFormProps = {
  children: React.ReactNode
}

export const SwapForm = ({ children }: SwapFormProps) => {
  const { onSubmit } = useSwapContext()

  const { handleSubmit } = useFormContext<SwapFlowFormValues>()

  return <Form onSubmit={handleSubmit(onSubmit)}>{children}</Form>
}
